import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import { ComingSoon } from "../components/common/coming-soon";

export const Views = () => {
  return (
    <Switch>
      {/* <Route exact path="/notifications" component={ComingSoon} /> */}
      <Route
        path="/notifications"
        render={() => <Redirect to={"/notfound"} />}
      />
    </Switch>
  );
};
